<script>    
   export let buttontext;
  </script>
  
  <style lang="scss">
    .btn.btn-primary {
        background: #4C12A1;
        border-radius: 100px;
        color:white;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 26px;
        margin-top: 16px;
        margin-bottom: 40px;
        padding: 11px 24px;
        @media(max-width:992px){
           width:100%;
           margin-left: auto;
           margin-right: auto;
        }
    }
    .btn.btn-primary:hover{
      background: #9AE6FF;
      color:#4C12A1;
      border:#4C12A1 2px solid;
    }
  </style> 
  <div class="d-grid d-md-block">
    <button on:click class="btn btn-primary md-block">
       <span class="text">{buttontext}</span>
    </button>
  </div>
